export default __webpack_public_path__ + "static/media/girl.da168e26.png";